import React, { useEffect, useRef, useState } from "react";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export function SignatureCard() {
  const [sig, setSig] = useState(null);
  const ref = useRef(null);
  useEffect(() => { api.get("/me/signature").then(({ data }) => setSig(data.data_url || null)).catch(() => {}); }, []);
  const pick = (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!/image\/(png|jpe?g)/.test(f.type)) { toast.error("Use a PNG or JPG image"); return; }
    if (f.size > 500 * 1024) { toast.error("Image must be under 500 KB"); return; }
    const rd = new FileReader();
    rd.onload = async () => {
      try { await api.put("/me/signature", { data_url: rd.result }); setSig(rd.result); toast.success("e-Signature saved"); }
      catch (err) { toast.error(err.response?.data?.detail || "Upload failed"); }
    };
    rd.readAsDataURL(f);
  };
  const remove = async () => { await api.delete("/me/signature"); setSig(null); toast.success("e-Signature removed"); };
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6" data-testid="signature-card">
      <div className="text-sm font-medium text-slate-800 mb-1">My e-Signature</div>
      <p className="text-xs text-slate-500 mb-4">Stamped on documents you approve, such as the Payroll Memo. Use a PNG (transparent background works best) or JPG under 500 KB.</p>
      <div className="h-24 rounded-lg border border-dashed border-slate-300 grid place-items-center bg-slate-50 mb-3">
        {sig ? <img src={sig} alt="My e-signature" className="max-h-20 max-w-full object-contain" data-testid="signature-preview" /> : <span className="text-xs text-slate-400" data-testid="signature-none">No signature uploaded</span>}
      </div>
      <input ref={ref} type="file" accept="image/png,image/jpeg" className="hidden" onChange={pick} data-testid="signature-file" />
      <div className="flex gap-2">
        <Button size="sm" onClick={() => ref.current?.click()} className="bg-blue-600 hover:bg-blue-700" data-testid="signature-upload-btn"><Icons.Upload className="h-3.5 w-3.5 mr-1" />{sig ? "Replace" : "Upload"}</Button>
        {sig && <Button size="sm" variant="outline" onClick={remove} data-testid="signature-remove-btn">Remove</Button>}
      </div>
    </div>
  );
}
